/* eslint-disable no-mixed-operators */
/* eslint-disable import/prefer-default-export */
import api from 'shared/services/api';
import numeral from 'numeral';
import { ACTION_TYPE } from './actionTypes';


export const getFinancialGoalService = () => (dispatch, getState) => new Promise((resolve) => {
  const { summary } = getState().rootReducer;
  const body = {
    annualInvestment: Number(numeral(summary['summary.annualInvestment'].split('KWD')[1]).format('0.0')),
    currency: 'KWD',
    initialAmount: Number(numeral(summary['summary.initialInvestment'].split('KWD')[1]).format('0.0')),
    period: Number(numeral(summary['summary.targetCompletion'].split(' year')[0]).format('0.0')),
    riskProfile: summary['summary.risk'],
    targetAmount: Number(numeral(summary['summary.targetAmount'].split('KWD')[1]).format('0.0')),
    investmentType: summary['summary.investmentPreference'] === 'islamic' ? 2 : 1,
    clientSegment: summary['summary.regulatoryClassification'] === 'qualified_investor' ? 'qualified' : 'retail',
  };
  api.getFinancialGoal(body).then((res) => {
    dispatch({
      type: ACTION_TYPE.GET_GOAL_SUMMARY_INVESTMENT_GOAL,
      payload: {
        currency: res.currency,
        highInvestmentValue: res.highInvestmentValue,
        lowInvestmentValue: res.lowInvestmentValue,
        messageResultCode: res.messageResultCode,
        messageResultTextArabic: res.messageResultTextArabic,
        messageResultTextEn: res.messageResultTextEn,
        period: res.period,
        pastPerformanceList: res.pastPerformanceList,
      },
    });
    resolve();
  });
});
